require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-clarifying-the-5-plus-roles-of-a-front-end-web-developer.json") })
        }
      }, "path---blog-clarifying-the-5-plus-roles-of-a-front-end-web-developer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-clarifying-the-5-plus-roles-of-a-front-end-web-developer!./.cache/json/blog-clarifying-the-5-plus-roles-of-a-front-end-web-developer.json
// module id = 745
// module chunks = 231608221292675